import { association, Factory } from 'miragejs';

export default Factory.extend({
  room: association(),

  isOnline: (i) => i % 4 !== 0,
});
